import { balance } from "./balance";

export const credit = {
    balance,
};
